import { Component } from '@angular/core';
import { Table } from 'primeng/table';
import { Blog } from 'src/app/models/common/BlogLoginResp';
import { LogService } from 'src/app/services/common/log.service';
import { Router } from '@angular/router';
import { BlogService } from 'src/app/services/app/blog.service';
import { AuthService } from 'src/app/services/app/auth.service';
import { NgClass } from '@angular/common';
import { TableModule } from 'primeng/table';
import { DividerModule } from 'primeng/divider';
import { InputTextModule } from 'primeng/inputtext';

@Component({
    standalone: true,
    selector: 'app-view-blog',
    templateUrl: './view-blog.component.html',
    styleUrls: ['./view-blog.component.css'],
    imports: [NgClass, DividerModule, TableModule, InputTextModule]
})
export class ViewBlogComponent {

  constructor(private router: Router,
    private authService: AuthService,
    private blogService: BlogService,
    private logService:LogService) { }

  displayStyle = "none";
  allBlog: Blog[] = [];
  userID:number;

  isErrorMessage = 0;

  hide = true;

  ngOnInit(): void {
    this.userID = +sessionStorage.getItem('UserID')
    this.GetAllBlog()
  }

  applyFilter(event: Event, dt: Table) {
    const filterValue = (event.target as HTMLInputElement).value;
    dt.filterGlobal(filterValue.trim().toLowerCase(), 'contains');
  }

  GetAllBlog() {
    try {
      this.allBlog = [];
      let user = { UserID: this.userID }
      this.blogService.GetAllBlog(user).subscribe(
        (result: Blog[]) => {
            result.forEach((element, index) => {
              element.srNo = index + 1
            });

            this.allBlog = result;
            console.log(this.allBlog)
        }, (err: Error) => {
          console.log(err.message);
        });
    }
    catch (ex) {
      this.logService.InsertExceptionLog(ex,"View Blog","GetAllBlog");
      console.log(ex);
    }
  }

  deleteBlog(blogID: number) {
    this.blogService.DeleteBlog(blogID).subscribe(
      () => {
        this.GetAllBlog();
      },
      (err: any) => {
        console.log(err.message);
      }
    );
    this.displayStyle = "block";
  }

  updateBlog(Blog: Blog) {
    this.router.navigate(
      ['add-blog'],
      { queryParams: { BlogId: Blog.blogID } });
  }

  addBlog() {
    this.router.navigate(
      ['add-blog']);
  }

  async logout(): Promise<void> {
    await this.authService.signOut('blog-login');
  }
}
